import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PHOTO_POST } from '../../api';
import useForm from '../../Hooks/useForm';
import Head from '../Helper/Head';
import useFetch from '../../Hooks/useFetch';
import Input from '../../Components/Form/Input';
import Button from '../../Components/Form/Button';
import Error from '../../Components/Helper/Error';
import styles from './UserPhotoPost.module.css';


const UserPhotoPost = () => {
  const nome = useForm();
  const peso = useForm('number');
  const idade = useForm('number');
  const [img, setImg] = React.useState({});
  const {data, error, loading, request} = useFetch();
  const navigate = useNavigate();
  
  React.useEffect(()=> {
    if(data) navigate('/account');
  }, [data, navigate]);
  function handleSubmit(event){
    event.preventDefault();
    const formData = new FormData();
    formData.append('img', img.raw);
    formData.append('nome', nome.value);
    formData.append('peso', peso.value);
    formData.append('idade', idade.value);
    const token = window.localStorage.getItem('token');
    const {url, options} = PHOTO_POST(formData,token);
    request(url, options);
  }
  function handleImgChange({target}){
    setImg({
      preview: URL.createObjectURL(target.files[0]),
      raw: target.files[0],

    })
  }
  return (
    <section className={`${styles.photoPost} animeLeft`}>
      <Head title="Poste sua foto"/>
      <form onSubmit={handleSubmit}>
        <Input label="Nome" type="text" name="nome" {...nome}/>
        <Input label="Peso" type="number" name="peso" {...peso}/>
        <Input label="Idade" type="number" name="idade" {...idade}/>
        <input type="file" name="img" id="img" onChange={handleImgChange} className={styles.file}/>
        {loading ? (
          <Button disabled>Enviando...</Button>
        ) : (
          <Button>Enviar</Button>
        )
      }
      <Error error={error}/>
      </form>

      <div>
        {img.preview && 
          <div className={styles.preview} style={{backgroundImage: `url('${img.preview}')`}}>

          </div>
        }
      </div>
      
    </section>
  )
}

export default UserPhotoPost
